import React, { Fragment, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Modal from "../../components/Modal";
import { TextField } from "@material-ui/core";
import { showToast, ToastType } from "../../utils/ToastUtil";
import { useToast } from "../../context/Toast/ToastProvider";
import {
  CancelPlanEmail,
  ChangePlanEmail,
  EnrollPlanEmail,
} from "../../services/patientService";
import { useStateAuthValue } from "../../context/Auth/AuthState";

const MyPlan = () => {
  const [{ userData, userToken }] = useStateAuthValue();
  const history = useHistory();
  const location = useLocation();
  const { typeClick } = location.state || {};
  const toastDispatch = useToast();
  const name = userData?.last_name + " " + userData?.first_name;
  const number = userData?.phone_number;
  const [open, setOpen] = useState(true);
  const [loading, setLoading] = useState(false);

  const getText = () => {
    if (!typeClick) {
      return "cambiar de Plan, agregar o eliminar una mascota a tus mascotas";
    }
    if (typeClick === "changePlan") {
      return "cambiar el plan de tu mascota";
    } else if (typeClick === "addPet") {
      return "agregar una mascota ";
    } else if (typeClick === "deletePet") {
      return "dar de baja el plan de tu mascota";
    }
  };

  const onClickFormHandler = async () => {
    try {
      setLoading(true);
      let message = "Información enviada correctamente.";
      if (!typeClick) {
        return "cambiar de Plan, agregar o eliminar una mascota a tus mascotas";
      }
      if (typeClick === "changePlan") {
        await ChangePlanEmail(userData.email, userToken);
        showToast(toastDispatch, message, ToastType.SUCCESS, "Ok!");
      } else if (typeClick === "addPet") {
        await EnrollPlanEmail(userData.email, userToken);
        showToast(toastDispatch, message, ToastType.SUCCESS, "Ok!");
      } else if (typeClick === "deletePet") {
        await CancelPlanEmail(userData.email, userToken);
        showToast(toastDispatch, message, ToastType.SUCCESS, "Ok!");
      }
    } catch (e) {
      showToast(
        toastDispatch,
        "Hubo un error al enviar la información, por favor, intentelo más tarde.",
        ToastType.ERROR,
        ToastType.ERROR
      );
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
    history.goBack();
  };

  return (
    <Fragment>
      <Modal isActive={open} handleClose={handleClose}>
        <div
          style={{
            padding: "20px 40px",
            position: "relative",
            bottom: "38px",
          }}
        >
          <div
            style={{
              color: "black",
              marginTop: "1rem",
            }}
          >
            <h1 style={{ fontWeight: "600" }}>Mi Plan</h1>
            <hr style={{ color: "#002C54" }} />
            <h3 style={{ fontSize: "22px", fontWeight: "600" }}>
              Titular: {name}
            </h3>
          </div>

          <h4
            style={{
              marginBottom: "20px",
              marginTop: "30px",
              fontSize: "20px",
            }}
          >
            Si queres {getText()}, por favor, completá los siguientes datos y un
            asesor de ventas te contactará en breve.
          </h4>
          <form style={{ display: "flex", flexDirection: "row" }}>
            <div
              style={{
                marginRight: "10rem",
              }}
            >
              <TextField
                id="outlined-read-only-input"
                label="Nombre"
                defaultValue={name}
                InputProps={{
                  readOnly: true,
                }}
              />
            </div>
            <div>
              <TextField
                id="outlined-read-only-input"
                label="Celular"
                defaultValue={number}
                InputProps={{
                  readOnly: true,
                }}
              />
            </div>
          </form>
          <button
            style={{
              marginTop: "2rem",
              width: "9rem",
              height: "33px",
              float: "right",
              borderRadius: "25px",
              border: "none",
              backgroundColor: loading ? "#ccc" : "#002c54",
              color: "white",
              cursor: loading ? "not-allowed" : "pointer",
            }}
            onClick={onClickFormHandler}
            disabled={loading}
          >
            {loading ? "Enviando..." : "Enviar"} {/* Show loading text */}
          </button>
        </div>
      </Modal>
    </Fragment>
  );
};

export default MyPlan;
